// AuthBridge.tsx
import { PropsWithChildren, useEffect } from 'react';
import { useUser } from '@hooks/useUser.ts';
import { authenticationApi } from '@api/api-config.ts';
import { useLocation, useNavigate } from '@tanstack/react-router';

export const AuthBridge: React.FC<PropsWithChildren> = ({ children }) => {
  const setBEUser = useUser(s => s.setBEUser);
  const beUser = useUser(s => s.beUser);
  const { pathname } = useLocation(); // Sleduje zmeny URL
  const navigate = useNavigate();

  // Veřejné stránky (magic link z e-mailu, přihlášení) - autorizuje podepsaný kód v URL, ne session.
  // POZOR: nový veřejný route prefix je potřeba přidat i sem, jinak guard přesměruje na /login.
  const guestPrefixes = ['/login', '/register', '/order-action', '/scheduled-order-action', '/lost-password', '/lost-login', '/reset-password'];
  const isAppPage = !guestPrefixes.some(path => pathname.startsWith(path));

  useEffect(() => {
    if (isAppPage && !beUser?.id) {
      authenticationApi
        .getCurrentUser()
        .then(d => {
          setBEUser(d.data);
        })
        .catch(err => {
          if (err.response?.status === 403 || err.response?.status === 401) {
            navigate({
              to: '/login',
            });
          }
        });
    }
  }, [isAppPage, pathname, setBEUser, beUser?.id, navigate]);

  if (isAppPage && !beUser?.id) {
    return <div>Loading...</div>;
  }

  return <>{children}</>;
};
